import Level1Icon from './level1.svg';
import Level2Icon from './level2.svg';
import Level3Icon from './level3.svg';

const VOLUME_BOOST_ICONS = {
  level1: Level1Icon,
  level2: Level2Icon,
  level3: Level3Icon,
};

export default VOLUME_BOOST_ICONS;

